<template>
    <v-card class="p-4 w-100 h-0 delegation">
        <div class="row align-items-start m-0 gap-2" :style="{ display: showSearchFields ? 'flex' : 'none' }">
            <div class="p-0 mt-2" style="width: 23%">
                <label class="mb-2">Document Type</label>
                <multi-select class="light-bg add-arrow" v-model="filter.category" label="name" placeholder="Select" track-by="id"
                            open-direction="bottom" :options="categories" :searchable="false" :internal-search="false"
                            :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                            :show-no-results="false" :hide-selected="false" :multiple="false" ref="multiselect1">
                </multi-select>
                    </div>
                    <div class="p-0 mt-2" style="width: 23%">
                        <label class="mb-2">Privacy</label>
                        <multi-select class="light-bg add-arrow" v-model="filter.privacy" label="name" placeholder="Select" track-by="id"
                            open-direction="bottom" :options="privacies" :searchable="false" :internal-search="false"
                            :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                            :show-no-results="false" :hide-selected="false" :multiple="false" ref="multiselect2">
                        </multi-select>
                    </div>
                    <div class="p-0 mt-2" style="width: 23%">
                        <label class="mb-2">Priority</label>
                        <multi-select class="light-bg add-arrow" v-model="filter.priority" label="name" placeholder="Select" track-by="id"
                            open-direction="bottom" :options="priorities" :searchable="false" :internal-search="false"
                            :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                            :show-no-results="false" :hide-selected="false" :multiple="false" ref="multiselect3">
                        </multi-select>
                    </div>
                    <div class="p-0 mt-2" style="width: 23%">
                        <label class="mb-2">{{ $t("res_Label_FromDate") }}</label>
                        <v-menu offset-y content-class="p-0" v-model="from_date_datePicker" :close-on-content-click="false">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field :value="utils.dateFormat(filter.from_date)" class="bg-white" label="" readonly
                                    v-bind="attrs" v-on="on" solo append-icon="mdi-calendar"
                                    :placeholder="constants.defaultDateValue">
                                    <template v-slot:append>
                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker id="advanced-date-menu" v-model="filter.from_date" @input="from_date_datePicker = false"></v-date-picker>
                        </v-menu>
                    </div>
                    <div class="p-0 mt-2" style="width: 23%">
                        <label class="mb-2">{{ $t("res_Label_ToDate") }}</label>
                        <v-menu content-class="p-0" offset-y v-model="to_date_datePicker" :close-on-content-click="false">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field :value="utils.dateFormat(filter.to_date)" label="" readonly v-bind="attrs"
                                    v-on="on" solo append-icon="mdi-calendar" :placeholder="constants.defaultDateValue">
                                    <template v-slot:append>
                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker id="advanced-date-menu" v-model="filter.to_date" @input="to_date_datePicker = false"></v-date-picker>
                        </v-menu>
                    </div>
                    <div class="p-0 mt-2" style="width: 23%">
                        <label class="mb-2">{{ $t("res_Label_Subject") }}</label>
                        <v-text-field v-model="filter.subject" type="text" class="search-field light-bg" :placeholder="$t('res_Placeholder_EnterSubject')"></v-text-field>
                    </div>
                    <div class="p-0 mt-2" style="width: 23%">
                        <label class="mb-2">{{ $t("res_MenuItems_ReferenceNumber") }}</label>
                        <v-text-field v-model="filter.referenceNumber" type="text" class="search-field light-bg" :placeholder="$t('res_Placeholder_EnterReference')"></v-text-field>
                    </div>

                    <div class="p-0 mt-2" style="width: 23%">
                        <label class="mb-2">Document Sender</label>
                        <v-text-field v-model="filter.documentSender" type="text" class="search-field light-bg"></v-text-field>
                    </div>
                    <div class="p-0 mt-2" style="width: 23%">
                        <label class="mb-2">Document Recepient</label>
                        <v-text-field v-model="filter.documentRecepient" type="text" class="search-field light-bg"></v-text-field>
                    </div>
                </div>
                <div class="mt-2 text-end">
                    <v-btn  dense   @click="showSearchFields = !showSearchFields"
                        class="expand-advance-search light-blue mr-2"><v-icon v-if="showSearchFields"> mdi-chevron-up </v-icon><v-icon v-if="!showSearchFields"> mdi-chevron-down </v-icon></v-btn>
                    <v-btn dense class="primary mr-2"  @click="SearchCorrespondence()">{{ $t("res_ButtonText_Search") }}</v-btn>
                    <v-btn dense class="light-blue mr-2"  @click="ClearAll()">{{ $t("res_Label_ClearAll") }}</v-btn>
                </div>
                <div>
            <div class="p-0 flex-1 overflow-auto">
                <div class="tab-content mt-4">
                    <div class="panel">
                        <div class="row m-auto">
                            <div :class="{ 'custom-col col-lg-7 col-xl-6 p-0 pr-5': openPreviewPane, 'col-md-12 p-0': !openPreviewPane }">
                                <v-layout column>
                                    <v-flex class="position-relative sm-margin mt-2" md12>
                                        <v-data-table :mobile-breakpoint="0" :headers="grid_headers" v-model="selected"
                                                      :items="correspondences" item-key="id" :items-per-page="pagingData.pageSize"
                                                      hide-default-footer class="elevation-1 empty-full-height" show-select
                                                      single-select :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                                                       @dblclick:row="openFullView"
                                                      @click:row="previewCorrespondence" @item-selected="itemSelected"
                                                      @update:sort-by="updateSortBy" @update:sort-desc="updateSortDesc" must-sort>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>
                            </div>
                            <div :class="{ 'custom-col col-lg-5 col-xl-6 p-0 py-2': openPreviewPane }"
                                 v-if="openPreviewPane">
                                <div class="h-100"
                                     style="background: #EFF2F5; border-radius: 12px; position: relative; overflow: hidden">
                                    <div>
                                        <v-btn class="close-btn d-block bg-white close-viewer " icon
                                               @click="closePreview()">
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </div>
                                    <!--viewer section-->
                                    <div class=" position-relative viewer-container scrollable-container"
                                         style="height: calc(100vh - 176px - 1rem); overflow-y: hidden;">
                                        <div v-if="empty_viewer" class="empty-viewer"
                                             style="border-radius: 12px; height: calc(100vh - 176px);">
                                            <img src="/assets/images/icons/template.svg" />
                                            <img src="/assets/images/icons/no_preview.svg" />
                                            <p class="mt-4 weight-400">{{ $t("res_Msgs_NoPreviewAvailable") }}</p>
                                        </div>
                                        <div v-if="!empty_viewer" id="viewer_template" class="h-100"
                                             style="border-radius: 12px;">
                                            <iframe id="viewerFrame" :src="viewerFrame" class="w-100"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <v-dialog v-model="correspondenceDialog" content-class="create-document-dialog fullscreen-dialog corr_dialog"
                  fullscreen >
            <div id="correspondenceDialogEmptyDiv"></div>
            <OldArchivedDocumentView  :closeDialogEvent="closeCorrespondenceDialog" :documentId="documentId" :mimeType="mimeType"  />
        </v-dialog>           
    </v-card>
</template>

<script>
import axios from 'axios';
import constants from '@/assets/js/constants'
import { defaultGet } from '@/assets/js/common.js'
import * as utils from '@/assets/js/common.js'
import router from '../router/index.js'
import MultiSelect from "vue-multiselect"
import OldArchivedDocumentView from '@/views/OldArchivedDocumentView.vue' 

export default {
    name: 'AdfdSearch',
    components: { MultiSelect,OldArchivedDocumentView },
    data() {
        const vm = this;
        return {
            documentId:0,
            openPreviewPane: false,
            router: router,
            showSearchFields:true,
            constants: constants,
            utils: utils,
            categories: [{ id: 0, name: '' }],
            privacies: [],
            priorities: [],
            from_date_datePicker: false,
            to_date_datePicker: false,
            correspondences: [],
            filter: {
                category: {},
                privacy: {},
                priority: {},
                from_date: '',
                to_date: '',
                subject: '',
                referenceNumber: '',
                documentSender: '',
                documentRecepient: '',
            },
            correspondenceDialog:false,
            viewerFrame:false,
            sortBy: 'id',
            sortDesc: true,
            grid_headers: [
                { text: '', value: 'data-table-select' },
                { text: 'Category', value: 'documentCategory', sortable: false },
                { text: 'Subject', value: 'subject', sortable: false },
                { text: 'Reference', value: 'reference', sortable: false },
                { text: 'Date', value: 'createdDate', sortable:false },
                { text: 'Sender', value: 'sender', sortable: false },
                { text: 'Recipient', value: 'doc_Recipient', sortable: false },
                { text: '', value: 'flag', sortable: false },
                { text: '', value: 'attachment', sortable: false },
            ],
            pagingData: {
                pageSize: 20,
                pageIndex: 0
            },
            selectedItem: null,
            selected: []
        };
    },
    mounted() 
    {
        this.categories = constants.categories
        this.privacies = constants.privacies;
        this.priorities = constants.priorities;
         this.grid_headers = [
             { text: '', value: 'data-table-select' },
             { text: window.translate("res_GridHeaders_Category"), value: 'documentCategory', sortable: false },
             { text: window.translate("res_GridHeaders_CreatedSubject"), value: 'subject', sortable: false },
             { text: window.translate("res_Label_ReferencenNo"), value: 'reference', sortable: false },
             { text: window.translate("res_GridHeaders_CreatedDate"), value: 'createdDate', sortable:false },
             { text: window.translate("res_Label_Sender"), value: 'sender', sortable: false },
             { text: window.translate("res_GridHeaders_Recipient"), value: 'doc_Recipient', sortable: false },
             { text: '', value: 'flag', sortable: false },
             { text: '', value: 'attachment', sortable: false },
         ]
    },
    methods: 
    {
        closeCorrespondenceDialog() {
                this.documentId = 0
                this.correspondenceDialog = false   
            },
        ClearAll(){
            this.showSearchFields=true
        },
        openFullView(){
            this.correspondenceDialog = true
            var item = this.selectedItem.item
            this.documentId = item.documentId
            this.mimeType=item.mimeType
            this.closePreview();
            setTimeout(() => {
                document.getElementById('correspondenceDialogEmptyDiv').parentElement.parentElement.classList.add('transparentBg');
            }, 10);
            // }
            
        },
        previewCorrespondence(item, row){
            if (!item.openedForPreview) {
                    item.openedForPreview = true;
                }

                this.selected = []
                this.selectedItem = { 'item': item, 'value': true }
                this.openPreviewPane = true

                if (item.attachmentId == null || item.attachmentId == undefined) {
                    this.empty_viewer = true
                }
                else {
                    var data = { docId:item.id, mimeType:item.mimeType }
                    axios.get(constants.baseApiUrl + 'Integrations/DownloadOpenTextDocuments?docId='+item.id+'&mimeType='+item.mimeType)
                    .then((res) => {
                        if(res.data!='')
                        {
                            this.empty_viewer = false
                            window.setViewerData(null,null,null,res.data);
                            this.viewerFrame = '/resources/viewer/viewer.html?lang=' + this.$i18n.locale + '&defaultScale=page-fit&pageMode=view' +
                                '&viewerMode=collapsed&r=' + new Date().getTime()
                        }
                    })
                    .catch((err) => console.log(err))
                    .finally(() =>
                        !this.hideSpinner ? window.hideLoading() : this.hideSpinner = !this.hideSpinner
                    )

                    
                }
        },
        closePreview() {
                this.selectedItem = null
                this.openPreviewPane = false
            },
        itemSelected(item, value) {
            if (item.value == true) {
                    this.selectedItem = item
                }
                else {
                    this.selectedItem = null
                }
        },
        updateSortBy() {

        },
        updateSortDesc() {
            
        },
        handleExportedFilters(updatedFilters) {

        },
        prepareSearchAndExportQuery() {
                const queryObject = {};

                queryObject.pageIndex = this.pagingData.pageIndex;
                queryObject.pageSize = this.pagingData.pageSize;
                queryObject.sortBy = this.sortBy;
                queryObject.sortDir = this.sortDesc ? 'desc' : 'asc';

                if (!utils.CheckIfNullOrEmpty(this.filter.subject)) {
                    queryObject.subject = this.filter.subject;
                }

                if (!utils.CheckIfNullOrEmpty(this.filter.referenceNumber)) {
                    queryObject.referenceNumber = this.filter.referenceNumber;
                }

                if (!utils.CheckIfNullOrEmpty(this.filter.from_date)) {
                    queryObject.fromDate = this.filter.from_date;
                }

                if (!utils.CheckIfNullOrEmpty(this.filter.to_date)) {
                    queryObject.toDate = this.filter.to_date;
                }

                if (this.filter.documentSender.id > 0) {
                    queryObject.documentSender = this.filter.documentSender.id;
                }

                if (this.filter.documentRecepient.id > 0) {
                    queryObject.documentRecepient = this.filter.documentRecepient.id;
                }

                if (this.filter.category.id > 0) {
                    queryObject.categoryId = this.filter.category.id;
                }

                if (this.filter.privacy.id > 0) {
                    queryObject.privacyId = this.filter.privacy.id;
                }

                if (this.filter.priority.id > 0) {
                    queryObject.priorityId = this.filter.priority.id;
                }

                return queryObject;
            },
        SearchCorrespondence() {
            var query = this.prepareSearchAndExportQuery();
            axios.post(constants.baseApiUrl + `Integrations/OpenTextSearch`, query)
                    .then((res) => {
                        if (utils.CheckIfNullOrEmpty(res)) {
                            window.showAlert('res_Msgs_ErrorOccured', 'error')
                            return;
                        }

                        this.correspondences = [];
                        this.correspondences = res.data
                        this.showSearchFields=false
                        
                    })
                    .catch((err) => console.log(err))
                    .finally(() =>
                        !this.hideSpinner ? window.hideLoading() : this.hideSpinner = !this.hideSpinner
                    )
        }
    }
}
</script>